import React from "react";
import PropTypes from "prop-types";

import styles from "./progressBar.scss";

export default function ProgressBar({ value, max = 100 }) {

	return (
		<div className={styles.progress_bar}>
			<progress value={value} max={max} />
			<div className={styles.progress_bar_text} style={{ width: value+"%" }}>{(value / max) * 100}% completed</div>
		</div>
	);
}

ProgressBar.propTypes = {
	value: PropTypes.number.isRequired,
	max: PropTypes.number,
};
